<template>
  <div>
    <popper placement="right" @open:popper="setTrailers">
      <span role="button" class="text-center text-success text-uppercase add-trailer-btn">
        Dodaj naczepę
      </span>
      <template #content>
        <div>
          <label>
            Zawęź wyniki wpisując tekst:
            <input type="text" v-model="TrailersSearchText" class="form-control" @input="FilterTrailers">
          </label>
          <label class="d-block mt-2">
            Dodaj nową naczepę z listy:
            <select
              class="d-inline form-select"
              v-model="selectedTrailerId"
              required
            >
              <option
                :value="null"
                selected
              >
              -- wybierz naczepę --
              </option>
              <option v-for="trailer in TrailersSelected" :key="trailer.id" :value="trailer.id">
                {{trailer.plateNumber}} ({{ trailer.parking ? trailer.parking.name : (trailer.vehiclePlateNumber ?? 'Brak informacji') }})
              </option>
            </select>
            <div class="text-center mt-3">
              <button class="btn btn-primary" @click="attachTrailerToVehicle()">
                Dodaj naczepę
              </button>
            </div>
          </label>
        </div>
      </template>
    </popper>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import Popper from 'vue3-popper'
import emitter from '@/modules/events/emitter'
import { compareByParking, compareByParkingName, compareByTrailerName } from '@/comparators/trailers'
import { mapActions, mapGetters } from 'vuex'
import eventKinds from '@/modules/events/eventKinds'
import { $axios } from '@/modules/http/axios'

export default {
  props: ['vehicleId'],
  components: { Popper },
  data () {
    return {
      selectedTrailerId: null,
      TrailersSearchText: '',
      TrailersSelected: null,
    }
  },
  computed: {
    ...mapGetters({
      trailers: 'getCalendarTrailers',
      vehicles: 'vehiclesModule/getVehicles'
    })
  },
  methods: {
    ...mapActions({
      fetchVehicles: 'vehiclesModule/fetchVehicles'
    }),
    setTrailers () {
      this.TrailersSelected = this.trailers.filter((trailer) => {
        return trailer.hidden === false
      })
      this.sortTrailers()
      this.setTrailerVehicles()
    },
    FilterTrailers () {
      if (this.TrailersSearchText !== '') {
        this.TrailersSelected = this.trailers.filter(trailer => {
          return trailer.plateNumber.toLowerCase().includes(this.TrailersSearchText.toLowerCase()) ||
            trailer.parking?.name?.toLowerCase()?.includes(this.TrailersSearchText.toLowerCase())
        })
        this.sortTrailers()
      } else {
        this.setTrailers()
      }
    },
    sortTrailers () {
      this.TrailersSelected = this.TrailersSelected.sort(compareByTrailerName).sort(compareByParkingName).sort(compareByParking)
    },
    setTrailerVehicles () {
      this.TrailersSelected.map(t => {
        t.vehiclePlateNumber = this.vehicles.find(v => v.semiTrailer?.id === t.id)?.plateNumber
      })
    },
    async attachTrailerToVehicle () {
      const postData = { semitrailerId: this.selectedTrailerId }

      try {
        await $axios.post(`Vehicle/Vehicle/${this.vehicleId}/Semitrailer`, postData)
        await Swal.fire('Przypięto naczepę do ciągnika', '', 'success')
        emitter.emit('vehicleChanged', { vehicleId: this.vehicleId })
        emitter.emit(eventKinds.trailerAttached)
        this.fetchVehicles().then(() => this.setTrailerVehicles())
      } catch (e) {
        await Swal.fire('Naczepa jest już używana przy innym pojeździe', '', 'error')
      }
    }
  }
}
</script>

<style scoped>
  .add-trailer-btn {
    transition: .4s;
    font-size: .6rem;
    text-decoration: underline;
  }

  .add-trailer-btn:hover {
    font-weight: 700;
  }
</style>
